export const FUNCTIONAL_COOKIES = {
  title: 'Functional Cookies',
  description: 'Enhance user experience by remembering settings.',
  linkedCategory: 'functional',
  cookieTable: {
    caption: '',
    headers: {
      name: 'Name',
      domain: 'Domain',
      duration: 'Expiration',
      description: 'Description',
    },
    body: [
      // Mailer Lite
      {
        name: 'mailerlite:forms:submitted:*',
        omain: 'mailerlite.com',
        duration: '1 year 1 month 4 days',
        description:
          "This cookie is used by the mailing list plugin to show which user's have submitted the webform",
      },
      {
        name: 'mailerlite:forms:shown:*',
        domain: 'mailerlite.com',
        duration: '27 days',
        description:
          'We use this cookie to determine if website visitor has seen your pop-up or not, and when to show the pop-up again regarding your behavior settings',
      },

      // Gartner
      {
        name: 'route-gcrowd-fe-prod',
        domain: 'gartner.com',
        duration: 'session',
        description:
          'Gartner sets this cookie to display Gartner expert advice from the Magic Quadrant and user-contributed ratings and reviews from Peer Insights',
      },
    ],
  },
};
